import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppBubble from "./components/WhatsAppBubble";
import RouteSeo from "./components/RouteSeo";
import Landing from "./pages/Landing";
import BookingResult from "./pages/BookingResult";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PalermoExperience from "./pages/PalermoExperience";
import CursoParrillero from "./pages/CursoParrillero";

function LandingShell() {
  return (
    <>
      <Header />
      <Landing />
      <Footer />
    </>
  );
}

function PalermoShell() {
  return (
    <>
      <Header />
      <PalermoExperience />
      <Footer />
    </>
  );
}

function CursoShell() {
  return (
    <>
      <Header />
      <CursoParrillero />
      <Footer />
    </>
  );
}

function ProtectedAdmin({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-[#A3A3A3]">...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      {/* BrowserRouter envuelve a I18nProvider: el idioma se deriva de la URL. */}
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <RouteSeo />
            <Toaster theme="dark" position="top-right" richColors />
            <WhatsAppBubble />
            <Routes>
              {/* Cada idioma tiene su propia URL — ver src/lib/routes.json */}
              <Route path="/" element={<LandingShell />} />
              <Route path="/en" element={<LandingShell />} />
              <Route path="/experiencia-asado-palermo-soho" element={<PalermoShell />} />
              <Route path="/en/asado-experience-palermo-soho" element={<PalermoShell />} />
              <Route path="/curso-de-parrillero" element={<CursoShell />} />
              <Route path="/en/argentine-asado-class" element={<CursoShell />} />
              <Route path="/booking/success" element={<BookingResult outcome="success" />} />
              <Route path="/booking/cancelled" element={<BookingResult outcome="cancelled" />} />
              <Route path="/booking/pending" element={<BookingResult outcome="success" />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
